import { getTranslations } from '@seek/libs-shared';
import translations from './.vocab';

const t = getTranslations(translations);

export const getCountryNameByCode = (
  countryCode: string,
  language: string,
): string => {
  return t(language, countryCode);
};
